@use 'themes/westfield' as *;
@use 'tools/color' as *;
@use 'tools/dirg' as *;
@use 'tools/dirg-breakpoint' as *;

.FooterSection {
  display: flex;
  justify-content: space-between;

  + .FooterSection {
    margin-top: units(1.5);
    padding-top: units(1.5);
    border-top: 1px solid color('Grey Dark');

    @include breakpoint('phablet') {
      border-top: 0;
    }
  }

  @include breakpoint('tablet') {
    flex-direction: column;
  }
}
